/**
 * Detects if the error response uses the new backend format
 */
function isNewErrorFormat(data) {
  const newFormatCodes = [
    'VALIDATION_ERROR',
    'DUPLICATE_ERROR',
    'INVALID_FORMAT',
    'NOT_FOUND_ERROR',
  ]

  return data.code && newFormatCodes.includes(data.code)
}

/**
 * Transforms new error format to include legacy properties
 */
function transformErrorData(data) {
  const errorMessage = data.error || 'An error occurred'

  return {
    ...data,
    errors: [{
      message: errorMessage,
      code: data.code,
    }],

    details: errorMessage,
  }
}

/**
 * Installs the error transformation interceptor on the provided axios instance.
 * MUST be registered LAST in the interceptor chain so it runs FIRST for errors.
 */
export function axiosInterceptorErrorTransformation(axiosInstance) {
  axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
      if (!error.response?.data) {
        return Promise.reject(error)
      }

      const data = error.response.data

      if (isNewErrorFormat(data)) {
        error.response.data = transformErrorData(data)
      }

      return Promise.reject(error)
    },
  )
}
